import { Card } from 'ui'
import { formatCurrency, titleize } from 'utils/billing'

import { intervalUnit, UpgradeFeatureList } from './UpgradePresentation'

export const UpgradeOrderSummary = ({ planName, upgrade = {} }) => {
  const amount = formatCurrency(upgrade.amount, upgrade.currency)
  const unit = intervalUnit(upgrade.interval)

  return (
    <aside className="tw:sticky tw:top-24 tw:self-start tw:shell:static">
      <Card>
        <div className="tw:p-5 tw:mobile:p-4">
          <h2 className="ds-heading-4">Order Summary</h2>
          <div className="tw:mt-5 tw:flex tw:items-start tw:justify-between tw:gap-4">
            <div>
              <div className="tw:font-semibold tw:text-foreground-strong">ExpanDrive {planName || 'subscription'}</div>
              <p className="ds-helper tw:mt-1">
                Server Edition · Web Management Console · priority support
              </p>
            </div>
            <span className="tw:shrink-0 tw:font-semibold tw:text-foreground-strong">{amount}</span>
          </div>

          <div className="tw:my-5 tw:border-t tw:border-default" />
          <div className="tw:flex tw:items-end tw:justify-between tw:gap-4">
            <div>
              <div className="ds-helper">Due today</div>
              <div className="ds-helper tw:mt-1">Then {amount}/{unit}. Cancel any time.</div>
            </div>
            <div className="tw:text-3xl tw:font-light tw:text-foreground-strong">{amount}</div>
          </div>

          <div className="tw:my-5 tw:border-t tw:border-default" />
          <UpgradeFeatureList className="tw:gap-3" />
          <p className="ds-helper tw:mt-4">Renews {titleize(upgrade.interval)} until canceled.</p>
        </div>
      </Card>
    </aside>
  )
}

export default UpgradeOrderSummary
